import React, { useEffect, useState } from 'react';
import CustomInput from '../../../components/customInput';
import CustomButton from '../../../components/customButton';
import utils from '../../../utils';
import SiteSelector from '../../../components/siteSelector';

const WINDOWS_APP_DOWNLOAD_URL =
  'https://dist.admobilize.com/stable/desktop-ui/windows/x64/admobilize-desktop-ui-2.2.0-win32-x64.msi';
const OS_LIST = [
  // { value: 'balena', label: 'Balena' },
  // { value: 'brightsign', label: 'Brightsign' },
  // { value: 'linux', label: 'Linux' }, //TODO: add linux later
  { value: 'windows', label: 'Windows' }
];

const getApplicationId = site => {
  const solution = site?.solution?.toUpperCase();

  return solution === 'AUDIENCE' || solution === 'FACEV2' ? 'FACEV2' : 'VEHICLECROWD';
};

const CreateDeviceSection = ({ setNewDevice, newDevice, mode = 'full', onOsSelected }) => {
  const [displayName, setDisplayName] = useState('');
  const [site, setSite] = useState({ label: 'Select site', value: null });
  const [errors, setErrors] = useState({});

  const showDeviceFields = mode === 'linux' || mode === 'full';

  useEffect(() => {
    if (!newDevice) {
      setDisplayName('');
      setSite({ label: 'Select site', value: null });
    }
  }, [newDevice]);

  useEffect(() => {
    const validation = {
      'device-display-name': [
        { key: 'required', value: true },
        { key: 'min', value: 4 }
      ]
    };

    const errorList = {
      'device-display-name': utils.fieldValidation(displayName, validation['device-display-name']).join(', ')
    };
    setErrors(errorList);
  }, [displayName]);

  useEffect(() => {
    if (!showDeviceFields) return;

    setNewDevice(currentDevice => ({
      ...currentDevice,
      displayName,
      site: site,
      hasErrors: errors
    }));
  }, [displayName, site, errors, showDeviceFields]);

  const handleSiteSelection = site => {
    setSite({
      label: `${site.displayName} - ${site.id}`,
      value: site.id,
      applicationId: getApplicationId(site)
    });
  };

  const downloadWindowsApp = event => {
    event.preventDefault();
    window.open(WINDOWS_APP_DOWNLOAD_URL, '_blank', 'noopener,noreferrer');
  };

  const selectOs = (event, os) => {
    event.preventDefault();
    onOsSelected(os);
  };

  return (
    <div className="create-device">
      <form>
        {mode === 'os' && (
          <div className="os-selection">
            {OS_LIST.map(os => (
              <CustomButton
                key={os.value}
                classes="btn btn-secondary"
                icon={os.value}
                title={os.label}
                handleClick={event => selectOs(event, os.value)}
              />
            ))}
          </div>
        )}
        {mode === 'windows' && (
          <div className="windows-app-download">
            <CustomButton
              classes="btn btn-secondary"
              title="Download Windows App"
              icon="download"
              handleClick={downloadWindowsApp}
            />
          </div>
        )}
        {showDeviceFields && (
          <div className="row">
            <div className="form-group col-6">
              <label>Device Name*</label>
              <CustomInput
                id="create-devices-name"
                type="text"
                value={displayName}
                isEditable={true}
                onChange={e => setDisplayName(e.target.value)}
                autoFocus={true}
                errorMessage={errors['device-display-name']}
              />
            </div>
          </div>
        )}
        {showDeviceFields && (
          <div className="row">
            <div className="form-group col">
              <label>Site*</label>
              <SiteSelector customLabel={''} onSelection={handleSiteSelection} customSelected={site} outline={true} />
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default CreateDeviceSection;
